function getEnv() {
  let origin = window.location.origin

  if (origin.includes('open.dev')) {
    origin = 'https://twinsmt.dev.iol8.net'
  } else if (
    origin.includes('open.qa') ||
    origin.includes('open1.qa') ||
    origin.includes('open2.qa')
  ) {
    origin = 'https://twinsmt.qa.iol8.net'
  } else if (origin.includes('open.release')) {
    origin = 'https://twinsmt.release.iol8.net'
  } else if (origin.includes('open.iol8')) {
    origin = 'https://twinsmt.iol8.com'
  }

  const obj = {
    host: origin,
    webcatHost: origin + '/go/webcat_pc',
    wordpower: origin + '/go/wp_pc_login',
    login: origin + '/go/passport_pc',
    recharge: origin + '/go/wealth_pc_login/recharge',
    build: origin + '/club/data/',
    pe: origin + '/go/pe_pc_login',
    im: origin + '/go/im_pc',
    yudao: origin + '/open/',
    mWordpower: origin + '/go/wp_h5_login',
    termCorpus: origin + '/go/termcorpus_pc/',
    toTwinsHome: origin + '/go/tw_pc_login/',
  }
  return obj
}

window.env = getEnv()

window.config = {
  env: window.env,
  host: window.env.host,
  webcat: window.env.webcatHost,
  im: window.env.imHost,
  wordpower: window.env.wordpower,
  login: window.env.login,
  recharge: window.env.recharge,
  build: window.env.build,
  pe: window.env.pe,
  im: window.env.im,
  yudao: window.env.yudao,
  mWordpower: window.env.mWordpower,
  termCorpus: window.env.termCorpus,
  toTwinsHome: window.env.toTwinsHome,
}
